import { gql } from '@apollo/client';

export const viaRacewayFragments = {
  viaRacewayItem: gql`
    fragment ViaRacewayItem on ViaRaceway {
      racewayId
      racewayTag
      serviceLevelRacewayId
      serviceLevelRacewayName
      isBarriered
      isRecalcRequired
      racewayType
      racewayCodeTag
      primaryStatus
      engineeringStatus
      secondaryStatus
      constructionStatus
      parentSecondaryStatus
      addlServiceLevelRacewayId
      addlServiceLevelRacewayName
      separationGroupRacewayId
      separationGroupRacewayName
      engrLength
      totalNoOfCables
      totalPctFill
      totalAvailPctFill
      totalAvailSpace
      totalWeightPerUnit
      totalOverfillFlag
      totalOverweightFlag
      removeRacewayHold
    }
  `,
};

export const ROUTE_BY_CABLE_ID = gql`
  ${viaRacewayFragments.viaRacewayItem}
  query RouteByCableId($cableId: ID!) {
    routeByCableId(cableId: $cableId) {
      viaRaceways {
        ...ViaRacewayItem
      }
    }
  }
`;

export const AVAILABLE_VIA_BY_EQUIPMENT = gql`
  ${viaRacewayFragments.viaRacewayItem}
  query AvailableViaByEquipment($viasByEquipmentInput: ViasByEquipmentInput!) {
    availableViasByEquipment(viasByEquipmentInput: $viasByEquipmentInput) {
      errors
      viaRaceways {
        ...ViaRacewayItem
      }
    }
  }
`;

export const AVAILABLE_VIA_BY_RACEWAY = gql`
  ${viaRacewayFragments.viaRacewayItem}
  query AvailableViasByRaceway($viasByRacewayInput: ViasByRacewayInput!) {
    availableViasByRaceway(viasByRacewayInput: $viasByRacewayInput) {
      errors
      viaRaceways {
        ...ViaRacewayItem
      }
    }
  }
`;

export const ISSUE_ROUTES = gql`
  mutation IssueRoutes($issueRoutesInput: [IssueRouteInput!]!) {
    issueRoutes(issueRoutesInput: $issueRoutesInput) {
      cables {
        id
        routeEngrStatus
      }
      errors {
        messageKeys
        tag
      }
    }
  }
`;

export const SAVE_ROUTE = gql`
  ${viaRacewayFragments.viaRacewayItem}
  mutation SaveRoute($saveRouteInput: SaveRouteInput!) {
    saveRoute(saveRouteInput: $saveRouteInput) {
      errors
      infos
      viaRaceways {
        ...ViaRacewayItem
      }
    }
  }
`;

export const CHECK_ROUTE = gql`
  ${viaRacewayFragments.viaRacewayItem}
  query CheckRoute($checkRouteInput: CheckRouteInput!) {
    checkRoute(checkRouteInput: $checkRouteInput) {
      errors
      infos
      viaRaceway {
        ...ViaRacewayItem
      }
    }
  }
`;

export const GET_COPIED_VIAS = gql`
  ${viaRacewayFragments.viaRacewayItem}
  query GetCopiedVias($copyViaInput: CopyViaInput!) {
    copiedVias(copyViaInput: $copyViaInput) {
      errors {
        tag
        messageKeys
      }
      infos {
        tag
        messageKeys
      }
      viaRaceways {
        ...ViaRacewayItem
      }
    }
  }
`;

export const SEARCH_ROUTE = gql`
  ${viaRacewayFragments.viaRacewayItem}
  query SearchRoute($searchRouteInput: SearchRouteInput!) {
    searchRoute(searchRouteInput: $searchRouteInput) {
      infos
      errors
      viaRaceways {
        ...ViaRacewayItem
      }
      availableViaRaceways {
        ...ViaRacewayItem
      }
    }
  }
`;
